import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import Placeholder from '../../../components/Placeholder';
import TopPage from './TopPage/TopPage';
import HairCarePage from './HairCarePage/HairCarePage';
import ScalpCarePage from './ScalpCarePage/ScalpCarePage';
import HairAndScalpCarePage from './HairAndScalpCarePage/HairAndScalpCarePage';
import SelectedCareMenuPage from './SelectedCareMenuPage/SelectedCareMenuPage';
import ConfirmPage from './ConfirmPage/ConfirmPage';
import HeaderTab from './HeaderTab/HeaderTab';

import { Container, Items, Item, PlaceholderWrapper } from './SublimicDiagnosisResultPage.style';

import updateDiagnosisResult from '../../../redux/actions/diagnosisResult';
import { getResultItemSlugsByDiagnosisLogic } from '../../../common/diagnosisLogic'; // 診断結果ロジックを元に結果アイテムのSlug情報を取得
import { homeCareItemFilter } from '../../../utils';
import { TABLET_P } from '../../../constants';
import { CATEGORY_HAIRCARE, CATEGORY_SCALPCARE, CATEGORY_HAIR_SCALP_CARE } from './CareMenuImage/CareMenuImageConst';

class SublimicDiagnosisResultPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSceneId: 'top',
      hairCare: null,
      inFillItems: null,
      maskItems: null,
      scalpCare: null,
      adenovitalItems: null,
      aromaItems: null,
      preCleanseShampooItems: null,
      homeCareHairItems: null,
      homeCareScalpItems: null,
      scrolled: false,
    };
  }

  componentWillMount = () => {
    const {
      authSalonSettings,
      diagnosisResult,
      updateDiagnosisResult,
      salonSolutionList,
      stylistDiagnosisResults,
      sublimicDiagnosisLogics,
      sublimicDiagnosisResult,
      homeCareList,
      homeCareLineList,
      scalpCameraDiagnosis,
    } = this.props;
    const { selectedHairCare, selectedScalpCare } = diagnosisResult;
    // console.log('@ SublimicDiagnosisResultPage', this.props);
    if (
      !Object.keys(salonSolutionList).length ||
      !Object.keys(authSalonSettings).length ||
      !Object.keys(stylistDiagnosisResults).length ||
      !Object.keys(sublimicDiagnosisLogics).length
    ) {
      return;
    }

    // ソリューション
    let hairCare = null;
    let scalpCare = null;
    if (salonSolutionList && authSalonSettings && stylistDiagnosisResults && sublimicDiagnosisLogics) {
      hairCare = this.salonSolutionHairFilter(
        salonSolutionList,
        authSalonSettings,
        stylistDiagnosisResults,
        sublimicDiagnosisLogics
      );
      scalpCare = this.salonSolutionScalpFilter(
        salonSolutionList,
        authSalonSettings,
        stylistDiagnosisResults,
        sublimicDiagnosisLogics
      );
    }
    // console.log('ヘアケア', hairCare);
    // console.log('スカルプケア', scalpCare);

    const { authSalonSettingData: newAuthSalonSettingData } = homeCareItemFilter(homeCareLineList, authSalonSettings);

    // インフィルアイテム
    const inFillItems = this.getInFillItems(
      salonSolutionList,
      newAuthSalonSettingData,
      stylistDiagnosisResults,
      sublimicDiagnosisLogics
    );
    // console.log('インフィルアイテム', inFillItems);

    // マスクアイテム
    const maskItems = this.getMaskItems(
      salonSolutionList,
      newAuthSalonSettingData,
      stylistDiagnosisResults,
      sublimicDiagnosisLogics
    );
    // console.log('マスクアイテム', maskItems);

    // アデノバイタルアイテム
    const adenovitalItems = this.getAdenovitalItems(
      salonSolutionList,
      newAuthSalonSettingData,
      stylistDiagnosisResults,
      sublimicDiagnosisLogics
    );
    // console.log('アデノバイタルアイテム', adenovitalItems);

    // アロマアイテム
    const aromaItems = this.getAromaItems(
      salonSolutionList,
      newAuthSalonSettingData,
      stylistDiagnosisResults,
      sublimicDiagnosisLogics
    );
    // console.log('アロマアイテム', aromaItems);

    // プレクレンズ&シャンプーアイテム
    const preCleanseShampooItems = this.getPreCleanseShampooItems(
      salonSolutionList,
      newAuthSalonSettingData,
      stylistDiagnosisResults,
      sublimicDiagnosisLogics
    );
    // console.log('プレクレンズ&シャンプーアイテム', preCleanseShampooItems);

    // アイテム
    let homeCareHairItems = null;
    let homeCareScalpItems = null;
    const maskItem = maskItems && maskItems[0] ? maskItems[0] : null;
    const preCleanseShampooItem =
      preCleanseShampooItems && preCleanseShampooItems[0] ? preCleanseShampooItems[0] : null;
    if (homeCareList && newAuthSalonSettingData && stylistDiagnosisResults && sublimicDiagnosisLogics) {
      homeCareHairItems = this.homeCareItemHairFilter(
        homeCareList,
        newAuthSalonSettingData,
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        maskItem
      );
      homeCareScalpItems = this.homeCareItemScalpFilter(
        homeCareList,
        newAuthSalonSettingData,
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        preCleanseShampooItem
      );
    }
    // console.log('ホームケアアイテム（SalonMenuResult）', homeCareHairItems);
    // console.log('ホームケアアイテム（ScalpCare）', homeCareScalpItems);

    this.setState({
      hairCare: hairCare || null,
      inFillItems: inFillItems || null,
      maskItems: maskItems || null,
      scalpCare: scalpCare || null,
      adenovitalItems: adenovitalItems || null,
      aromaItems: aromaItems || null,
      preCleanseShampooItems: preCleanseShampooItems || null,
      homeCareHairItems: homeCareHairItems.recommendedResults.concat(homeCareHairItems.otherResults) || null,
      homeCareScalpItems: homeCareScalpItems.recommendedResults.concat(homeCareScalpItems.otherResults) || null,
    });

    // 診断結果保存
    if (!selectedHairCare || !selectedScalpCare) {
      if (hairCare && hairCare[0] && scalpCare && scalpCare[0] && stylistDiagnosisResults && sublimicDiagnosisResult) {
        const result = {
          selectedCareMenu: CATEGORY_HAIRCARE, // 本日受けたいメニュー
          selectedHairCare: hairCare && hairCare.length >= 1 ? hairCare[0] : null,
          selectedHairCareIndex: hairCare && hairCare.length >= 1 ? 0 : null,
          selectedInFillItem: inFillItems && inFillItems.length >= 1 ? inFillItems[0] : null, // 選択済みインフィルアイテム
          selectedInFillItemIndex: inFillItems && inFillItems.length >= 1 ? 0 : null, // 選択済みインフィルアイテム
          selectedMaskItem: maskItems && maskItems.length >= 1 ? maskItems[0] : null, // 選択済みマスクアイテム
          selectedMaskItemIndex: maskItems && maskItems.length >= 1 ? 0 : null, // 選択済みマスクアイテム
          selectedScalpCare: scalpCare && scalpCare.length >= 1 ? scalpCare[0] : null,
          selectedScalpCareIndex: scalpCare && scalpCare.length >= 1 ? 0 : null,
          selectedAdenovitalItem: adenovitalItems && adenovitalItems.length >= 1 ? adenovitalItems[0] : null, // 選択済みアデノバイタルアイテム
          selectedAdenovitalItemIndex: adenovitalItems && adenovitalItems.length >= 1 ? 0 : null, // 選択済みアデノバイタルアイテム
          selectedAromaItem: aromaItems && aromaItems.length >= 1 ? aromaItems[0] : null, // 選択済みアロマアイテム
          selectedAromaItemIndex: aromaItems && aromaItems.length >= 1 ? 0 : null, // 選択済みアロマアイテム
          selectedPreCleanseShampooItem:
            preCleanseShampooItems && preCleanseShampooItems.length >= 1 ? preCleanseShampooItems[0] : null, // 選択済みプレクレンズ&シャンプーアイテム
          selectedPreCleanseShampooItemIndex: preCleanseShampooItems && preCleanseShampooItems.length >= 1 ? 0 : null, // 選択済みプレクレンズ&シャンプーアイテム
          recommendedHairCare: hairCare && hairCare.length >= 1 ? hairCare[0] : null,
          recommendedInFillItem: inFillItems && inFillItems.length >= 1 ? inFillItems[0] : null, // おすすめインフィルアイテム
          recommendedMaskItem: maskItems && maskItems.length >= 1 ? maskItems[0] : null, // おすすめマスクアイテム
          recommendedScalpCare: scalpCare && scalpCare.length >= 1 ? scalpCare[0] : null,
          recommendedAdenovitalItem: adenovitalItems && adenovitalItems.length >= 1 ? adenovitalItems[0] : null, // おすすめアデノバイタルアイテム
          recommendedAromaItem: aromaItems && aromaItems.length >= 1 ? aromaItems[0] : null, // おすすめアロマアイテム
          recommendedPreCleanseShampooItems:
            preCleanseShampooItems && preCleanseShampooItems.length >= 1 ? preCleanseShampooItems[0] : null, // おすすめプレクレンズ&シャンプーアイテム
          selectedHomeCareHairItems:
            homeCareHairItems && homeCareHairItems.recommendedResults ? homeCareHairItems.recommendedResults : null,
          selectedHomeCareScalpItems:
            homeCareScalpItems && homeCareScalpItems.recommendedResults ? homeCareScalpItems.recommendedResults : null,
          recommendedHomeCareHairItems:
            homeCareHairItems && homeCareHairItems.recommendedResults ? homeCareHairItems.recommendedResults : null,
          recommendedHomeCareScalpItems:
            homeCareScalpItems && homeCareScalpItems.recommendedResults ? homeCareScalpItems.recommendedResults : null,
          diagnosisResults: {
            damageLevel: this.getDamageLevel(stylistDiagnosisResults) || null,
            currentImage:
              (scalpCameraDiagnosis &&
                scalpCameraDiagnosis.diagnosisResults &&
                scalpCameraDiagnosis.diagnosisResults.imageUrl) ||
              null,
            pin:
              (scalpCameraDiagnosis &&
                scalpCameraDiagnosis.diagnosisResults &&
                scalpCameraDiagnosis.diagnosisResults.pin) ||
              null,
            hairCurrentStatus: this.getHairCurrentStatus(stylistDiagnosisResults, sublimicDiagnosisResult) || null,
            hairNecessaryCare: this.getHairNecessaryCare(hairCare[0], sublimicDiagnosisResult) || null,
            scalpCurrentStatus:
              this.getScalpCurrentStatus(
                stylistDiagnosisResults,
                sublimicDiagnosisLogics,
                newAuthSalonSettingData,
                sublimicDiagnosisResult
              ) || null,
            scalpType:
              this.getScalpType(
                stylistDiagnosisResults,
                sublimicDiagnosisLogics,
                newAuthSalonSettingData,
                sublimicDiagnosisResult
              ) || null,
            scalpNecessaryCare: this.getScalpNecessaryCare(scalpCare[0], sublimicDiagnosisResult) || null,
          },
        };

        updateDiagnosisResult(result);
      }
    }
  };

  componentDidMount = () => {
    const { history, locale } = this.props;
    const { hairCare, scalpCare, homeCareHairItems, homeCareScalpItems } = this.state;
    if (!hairCare || !scalpCare || !homeCareHairItems || !homeCareScalpItems) {
      setTimeout(() => {
        history.push(`/${locale}/salon-consultation/sublimic/home`);
      }, 500);
    }
    window.addEventListener('scroll', () => this.watchCurrentPosition(), false);
    // 縦スクロールだけ有効にする
    document.body.style.overflow = 'hidden';
    document.body.style.overflowY = 'scroll';
  };

  componentWillUnmount = () => {
    window.removeEventListener('scroll', () => this.watchCurrentPosition(), false);
    // 縦スクロールだけ有効にする
    document.body.style.overflow = 'auto';
    document.body.style.overflowY = 'auto';
  };

  // ダメージレベル取得
  getDamageLevel = stylistDiagnosisResults => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.hairDiagnosis &&
      stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.hairDiagnosis &&
        stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-damagelevel') {
          if (Questions[i].answers[0] === 'ans-zero') {
            return '0';
          } else if (Questions[i].answers[0] === 'ans-one') {
            return '1';
          } else if (Questions[i].answers[0] === 'ans-two') {
            return '2';
          } else if (Questions[i].answers[0] === 'ans-three') {
            return '3';
          } else if (Questions[i].answers[0] === 'ans-four') {
            return '4';
          }
        }
      }
    }
    return null;
  };

  // 毛髪 : 現在の状態取得
  getHairCurrentStatus = (stylistDiagnosisResults, sublimicDiagnosisResult) => {
    if (stylistDiagnosisResults && sublimicDiagnosisResult && sublimicDiagnosisResult.hairCurrentStatus) {
      const currentDamageLevel = this.getDamageLevel(stylistDiagnosisResults) || null;
      if (currentDamageLevel) {
        for (let i = 0; i < sublimicDiagnosisResult.hairCurrentStatus.length; i += 1) {
          const status = sublimicDiagnosisResult.hairCurrentStatus[i];
          if (status && status.slug && status.description) {
            if (status.slug.indexOf(currentDamageLevel) >= 0) {
              return {
                slug: status.slug,
                description: status.description,
              };
            }
          }
        }
      }
    }
    return null;
  };

  // 毛髪 : 必要なケア
  getHairNecessaryCare = (recommendedItem, sublimicDiagnosisResult) => {
    if (recommendedItem && sublimicDiagnosisResult && sublimicDiagnosisResult.hairNecessaryCare) {
      for (let i = 0; i < sublimicDiagnosisResult.hairNecessaryCare.length; i += 1) {
        const status = sublimicDiagnosisResult.hairNecessaryCare[i];
        if (status && status.slug && status.description) {
          if (status.slug.indexOf(recommendedItem.slug) >= 0) {
            return {
              slug: status.slug,
              description: status.description,
            };
          }
        }
      }
    }
    return null;
  };

  // 頭皮 : 現在の状態取得
  getScalpCurrentStatus = (
    stylistDiagnosisResults,
    sublimicDiagnosisLogics,
    authSalonSettings,
    sublimicDiagnosisResult
  ) => {
    const resultItems = getResultItemSlugsByDiagnosisLogic(
      stylistDiagnosisResults,
      sublimicDiagnosisLogics,
      authSalonSettings,
      'Current Scalp Status'
    );
    if (
      resultItems &&
      resultItems.recommendedResults &&
      sublimicDiagnosisResult &&
      sublimicDiagnosisResult.scalpCurrentStatus
    ) {
      for (let i = 0; i < sublimicDiagnosisResult.scalpCurrentStatus.length; i += 1) {
        const status = sublimicDiagnosisResult.scalpCurrentStatus[i];
        if (status && status.slug && status.description) {
          if (status.slug === resultItems.recommendedResults[0].slug) {
            return {
              slug: status.slug,
              description: status.description,
            };
          }
        }
      }
    }
    return null;
  };

  // 頭皮 : 髪の密度と太さ取得
  getScalpType = (stylistDiagnosisResults, sublimicDiagnosisLogics, authSalonSettings, sublimicDiagnosisResult) => {
    const resultItems = getResultItemSlugsByDiagnosisLogic(
      stylistDiagnosisResults,
      sublimicDiagnosisLogics,
      authSalonSettings,
      'Density and Diameter'
    );
    if (
      resultItems &&
      resultItems.recommendedResults &&
      sublimicDiagnosisResult &&
      sublimicDiagnosisResult.scalpCurrentStatus
    ) {
      for (let i = 0; i < sublimicDiagnosisResult.scalpCurrentStatus.length; i += 1) {
        const status = sublimicDiagnosisResult.scalpCurrentStatus[i];
        if (status && status.slug && status.description) {
          if (status.slug === resultItems.recommendedResults[0].slug) {
            return {
              slug: status.slug,
              description: status.description,
            };
          }
        }
      }
    }
    return null;
  };

  // 頭皮 : 必要なケア
  getScalpNecessaryCare = (recommendedItem, sublimicDiagnosisResult) => {
    if (recommendedItem && sublimicDiagnosisResult && sublimicDiagnosisResult.scalpNecessaryCare) {
      for (let i = 0; i < sublimicDiagnosisResult.scalpNecessaryCare.length; i += 1) {
        const status = sublimicDiagnosisResult.scalpNecessaryCare[i];
        if (status && status.slug && status.description) {
          if (status.slug.indexOf(recommendedItem.slug) >= 0) {
            return {
              slug: status.slug,
              description: status.description,
            };
          }
        }
      }
    }
    return null;
  };

  // インフィルアイテム取得
  getInFillItems = (salonSolutionList, authSalonSettingData, stylistDiagnosisResults, sublimicDiagnosisLogics) => {
    if (stylistDiagnosisResults && sublimicDiagnosisLogics && authSalonSettingData) {
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      let resultItems = null;
      if (localStorage.getItem('useDiagnosis') === 'yes') {
        resultItems = getResultItemSlugsByDiagnosisLogic(
          stylistDiagnosisResults,
          sublimicDiagnosisLogics,
          authSalonSettingData,
          'Salon Solution Items Hair'
        );
      } else {
        resultItems = getResultItemSlugsByDiagnosisLogic(
          stylistDiagnosisResults,
          sublimicDiagnosisLogics,
          authSalonSettingData,
          'Hair Care Items Hair Quick'
        );
      }
      //
      let result = [];
      if (resultItems.recommendedResults !== null) {
        resultItems.recommendedResults.map(item => {
          if (item.category === 'In-fill') {
            result.push(item);
          }
        });
      }
      if (resultItems.otherResults !== null) {
        resultItems.otherResults.map(item => {
          if (item.category === 'In-fill') {
            result.push(item);
          }
        });
      }
      // authSalonSettingDataでフィルタ
      // console.log('インフィルアイテムフィルタ前', result, authSalonSettingData.homeCareItems, salonSolutionList.useItems);
      const arr = [];
      result.map(item => {
        salonSolutionList.useItems.map(useItem => {
          if (item.slug === useItem.slug) {
            if (!useItem.concern) {
              arr.push(item);
            } else if (authSalonSettingData.homeCareItems.indexOf(useItem.concern.slug) >= 0) {
              arr.push(item);
            }
          }
        });
      });
      result = arr;
      // console.log('インフィルアイテムフィルタ後', result);
      //
      const result2 = [];
      if (salonSolutionList && salonSolutionList.useItems) {
        result.map(item => {
          salonSolutionList.useItems.map(item2 => {
            if (item.slug === item2.slug) {
              result2.push(item2);
            }
          });
        });
      }
      if (result2.length >= 1) return result2;
      return null;
    }

    return null;
  };

  // マスクアイテム取得
  getMaskItems = (salonSolutionList, authSalonSettingData, stylistDiagnosisResults, sublimicDiagnosisLogics) => {
    if (stylistDiagnosisResults && sublimicDiagnosisLogics && authSalonSettingData) {
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      let resultItems = null;
      if (localStorage.getItem('useDiagnosis') === 'yes') {
        resultItems = getResultItemSlugsByDiagnosisLogic(
          stylistDiagnosisResults,
          sublimicDiagnosisLogics,
          authSalonSettingData,
          'Salon Solution Items Hair'
        );
      } else {
        resultItems = getResultItemSlugsByDiagnosisLogic(
          stylistDiagnosisResults,
          sublimicDiagnosisLogics,
          authSalonSettingData,
          'Hair Care Items Hair Quick'
        );
      }
      //
      let result = [];
      if (resultItems.recommendedResults !== null) {
        resultItems.recommendedResults.map(item => {
          if (item.category === 'Mask') {
            result.push(item);
          }
        });
      }
      if (resultItems.otherResults !== null) {
        resultItems.otherResults.map(item => {
          if (item.category === 'Mask') {
            result.push(item);
          }
        });
      }
      // authSalonSettingDataでフィルタ
      // console.log('マスクアイテムフィルタ前', result, authSalonSettingData.homeCareItems, salonSolutionList.useItems);
      const arr = [];
      result.map(item => {
        salonSolutionList.useItems.map(useItem => {
          if (item.slug === useItem.slug) {
            if (!useItem.concern) {
              arr.push(item);
            } else if (authSalonSettingData.homeCareItems.indexOf(useItem.concern.slug) >= 0) {
              arr.push(item);
            }
          }
        });
      });
      result = arr;
      // console.log('マスクアイテムフィルタ後', result);
      //
      const result2 = [];
      if (salonSolutionList && salonSolutionList.useItems) {
        result.map(item => {
          salonSolutionList.useItems.map(item2 => {
            if (item.slug === item2.slug) {
              result2.push(item2);
            }
          });
        });
      }
      if (result2.length >= 1) return result2;
      return null;
    }

    return null;
  };

  // アデノバイタルアイテム取得
  getAdenovitalItems = (salonSolutionList, authSalonSettingData, stylistDiagnosisResults, sublimicDiagnosisLogics) => {
    if (stylistDiagnosisResults && sublimicDiagnosisLogics && authSalonSettingData) {
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      const resultItems = getResultItemSlugsByDiagnosisLogic(
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        authSalonSettingData,
        'Salon Solution Items Scalp'
      );
      //
      let result = [];
      if (resultItems.recommendedResults !== null) {
        resultItems.recommendedResults.map(item => {
          if (item.category === 'Treatment') {
            result.push(item);
          }
        });
      }
      if (resultItems.otherResults !== null) {
        resultItems.otherResults.map(item => {
          if (item.category === 'Treatment') {
            result.push(item);
          }
        });
      }
      // authSalonSettingDataでフィルタ
      // console.log('アデノバイタルアイテムフィルタ前', result, authSalonSettingData.homeCareItems, salonSolutionList.useItems);
      const arr = [];
      result.map(item => {
        salonSolutionList.useItems.map(useItem => {
          if (item.slug === useItem.slug) {
            if (!useItem.concern) {
              arr.push(item);
            } else if (authSalonSettingData.homeCareItems.indexOf(useItem.concern.slug) >= 0) {
              arr.push(item);
            }
          }
        });
      });
      result = arr;
      // console.log('アデノバイタルアイテムフィルタ後', result);
      //
      const slugs = [];
      authSalonSettingData.salonMenus.spas.map(spa => {
        slugs.push(spa.slug);
      });
      if (
        slugs.indexOf('SS-S-Complete') === -1 &&
        slugs.indexOf('SS-S-Lifting') === -1 &&
        slugs.indexOf('SS-S-SolvingProblem') === -1
      ) {
        // SS-S-CompleteとSS-S-LiftingとSS-S-SolvingProblemがOffの場合はアデノバイタルを固定
        result = [
          {
            slug: 'SS-HairTreatment-ad',
            category: 'Treatment',
          },
          {
            slug: 'SS-ScalpTreatment-ad',
            category: 'Treatment',
          },
        ];
        // console.log('SS-S-CompleteとSS-S-LiftingとSS-S-SolvingProblemがOff', result);
      } else if (slugs.indexOf('SS-S-Gray') === -1 && slugs.indexOf('SS-S-Growth') === -1) {
        // SS-S-GrayとSS-S-GrowthがOffの場合はアデノバイタルを非表示
        result = [];
        // console.log('SS-S-GrayとSS-S-GrowthがOff', result);
      }
      //
      const result2 = [];
      if (salonSolutionList && salonSolutionList.useItems) {
        result.map(item => {
          salonSolutionList.useItems.map(item2 => {
            if (item.slug === item2.slug) {
              result2.push(item2);
            }
          });
        });
      }
      if (result2.length >= 1) return result2;
      return null;
    }

    return null;
  };

  // アロマアイテム取得
  getAromaItems = (salonSolutionList, authSalonSettingData, stylistDiagnosisResults, sublimicDiagnosisLogics) => {
    if (stylistDiagnosisResults && sublimicDiagnosisLogics && authSalonSettingData) {
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      let resultItems = null;
      if (localStorage.getItem('useDiagnosis') === 'yes') {
        resultItems = getResultItemSlugsByDiagnosisLogic(
          stylistDiagnosisResults,
          sublimicDiagnosisLogics,
          authSalonSettingData,
          'Salon Solution Items Scalp'
        );
      } else {
        resultItems = getResultItemSlugsByDiagnosisLogic(
          stylistDiagnosisResults,
          sublimicDiagnosisLogics,
          authSalonSettingData,
          'Hair Care Items Scalp Quick'
        );
      }
      //
      let result = [];
      if (resultItems.recommendedResults !== null) {
        resultItems.recommendedResults.map(item => {
          if (item.category === 'Aroma') {
            result.push(item);
          }
        });
      }
      if (resultItems.otherResults !== null) {
        resultItems.otherResults.map(item => {
          if (item.category === 'Aroma') {
            result.push(item);
          }
        });
      }
      // authSalonSettingDataでフィルタ
      // console.log('アロマアイテムフィルタ前', result, authSalonSettingData.homeCareItems, salonSolutionList.useItems);
      const arr = [];
      result.map(item => {
        salonSolutionList.useItems.map(useItem => {
          if (item.slug === useItem.slug) {
            if (!useItem.concern) {
              arr.push(item);
            } else if (authSalonSettingData.homeCareItems.indexOf(useItem.concern.slug) >= 0) {
              arr.push(item);
            }
          }
        });
      });
      result = arr;
      // console.log('アロマアイテムフィルタ後', result);
      //
      const slugs = [];
      authSalonSettingData.salonMenus.spas.map(spa => {
        slugs.push(spa.slug);
      });
      if (slugs.indexOf('SS-S-Gray') === -1 && slugs.indexOf('SS-S-Growth') === -1) {
        // SS-S-GrayとSS-S-GrowthがOffの場合はアロマを固定
        result = [
          {
            slug: 'SS-Aromaspadrop-refresh',
            category: 'Aroma',
          },
          {
            slug: 'SS-Aromaspadrop-relax',
            category: 'Aroma',
          },
        ];
        // console.log('SS-S-GrayとSS-S-GrowthがOff', result);
      } else if (
        slugs.indexOf('SS-S-Complete') === -1 &&
        slugs.indexOf('SS-S-Lifting') === -1 &&
        slugs.indexOf('SS-S-SolvingProblem') === -1
      ) {
        // SS-S-CompleteとSS-S-LiftingとSS-S-SolvingProblemがOffの場合はアロマを非表示
        result = [];
        // console.log('SS-S-CompleteとSS-S-LiftingとSS-S-SolvingProblemがOff', result);
      }
      //
      const result2 = [];
      if (salonSolutionList && salonSolutionList.useItems) {
        result.map(item => {
          salonSolutionList.useItems.map(item2 => {
            if (item.slug === item2.slug) {
              result2.push(item2);
            }
          });
        });
      }
      if (result2.length >= 1) return result2;
      return null;
    }

    return null;
  };

  // プレクレンズ&シャンプーアイテム取得
  getPreCleanseShampooItems = (
    salonSolutionList,
    authSalonSettingData,
    stylistDiagnosisResults,
    sublimicDiagnosisLogics
  ) => {
    if (stylistDiagnosisResults && sublimicDiagnosisLogics && authSalonSettingData) {
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      let resultItems = null;
      if (localStorage.getItem('useDiagnosis') === 'yes') {
        resultItems = getResultItemSlugsByDiagnosisLogic(
          stylistDiagnosisResults,
          sublimicDiagnosisLogics,
          authSalonSettingData,
          'Salon Solution Items Scalp'
        );
      } else {
        resultItems = getResultItemSlugsByDiagnosisLogic(
          stylistDiagnosisResults,
          sublimicDiagnosisLogics,
          authSalonSettingData,
          'Hair Care Items Scalp Quick'
        );
      }
      //
      let result = [];
      if (resultItems.recommendedResults !== null) {
        resultItems.recommendedResults.map(item => {
          if (item.category === 'Pre-Cleanse,shampoo') {
            result.push(item);
          }
        });
      }
      if (resultItems.otherResults !== null) {
        resultItems.otherResults.map(item => {
          if (item.category === 'Pre-Cleanse,shampoo') {
            result.push(item);
          }
        });
      }
      // authSalonSettingDataでフィルタ
      // console.log('プレクレンズ&シャンプーアイテムフィルタ前', result, authSalonSettingData.homeCareItems, salonSolutionList.useItems);
      const arr = [];
      result.map(item => {
        salonSolutionList.useItems.map(useItem => {
          if (item.slug === useItem.slug) {
            if (!useItem.concern) {
              arr.push(item);
            } else if (authSalonSettingData.homeCareItems.indexOf(useItem.concern.slug) >= 0) {
              arr.push(item);
            }
          }
        });
      });
      result = arr;
      // console.log('プレクレンズ&シャンプーアイテムフィルタ後', result);
      const slugs = [];
      authSalonSettingData.salonMenus.spas.map(spa => {
        slugs.push(spa.slug);
      });
      if (slugs.indexOf('SS-S-Gray') === -1 && slugs.indexOf('SS-S-Growth') === -1) {
        // SS-S-GrayとSS-S-GrowthがOffの場合はプレクレンズ&シャンプーを固定
        result = [
          {
            slug: 'SS-PrecleanseShampoods',
            category: 'Pre-Cleanse,shampoo',
          },
          {
            slug: 'SS-PrecleanseShampooos',
            category: 'Pre-Cleanse,shampoo',
          },
          {
            slug: 'SS-PrecleanseShampoodd',
            category: 'Pre-Cleanse,shampoo',
          },
        ];
        // console.log('SS-S-GrayとSS-S-GrowthがOff', result);
      } else if (
        slugs.indexOf('SS-S-Complete') === -1 &&
        slugs.indexOf('SS-S-Lifting') === -1 &&
        slugs.indexOf('SS-S-SolvingProblem') === -1
      ) {
        // SS-S-CompleteとSS-S-LiftingとSS-S-SolvingProblemがOffの場合はプレクレンズ&シャンプーを非表示
        result = [];
        // console.log('SS-S-CompleteとSS-S-LiftingとSS-S-SolvingProblemがOff', result);
      }
      //
      const result2 = [];
      if (salonSolutionList && salonSolutionList.useItems) {
        result.map(item => {
          salonSolutionList.useItems.map(item2 => {
            if (item.slug === item2.slug) {
              result2.push(item2);
            }
          });
        });
      }
      if (result2.length >= 1) return result2;
      return null;
    }

    return null;
  };

  getRecommendedHomeCareItemHair = (authSalonSettingData, stylistDiagnosisResults, sublimicDiagnosisLogics) => {
    if (stylistDiagnosisResults && sublimicDiagnosisLogics && authSalonSettingData) {
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      const resultItems = getResultItemSlugsByDiagnosisLogic(
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        authSalonSettingData,
        'Home Care Items Hair'
      );
      if (resultItems.recommendedResults !== null) {
        return resultItems.recommendedResults[0];
      }
    }

    return null;
  };

  getRecommendedHomeCareItemScalp = (authSalonSettingData, stylistDiagnosisResults, sublimicDiagnosisLogics) => {
    if (stylistDiagnosisResults && sublimicDiagnosisLogics && authSalonSettingData) {
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      const resultItems = getResultItemSlugsByDiagnosisLogic(
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        authSalonSettingData,
        'Home Care Items Scalp'
      );
      if (resultItems.recommendedResults !== null) {
        return resultItems.recommendedResults[0];
      }
    }

    return null;
  };

  watchCurrentPosition = () => {
    const currentPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    if (currentPosition > 40) {
      this.setState({ scrolled: true });
    } else {
      this.setState({ scrolled: false });
    }
  };

  salonSolutionHairFilter = (
    salonSolutionList,
    authSalonSettings,
    stylistDiagnosisResults,
    sublimicDiagnosisLogics
  ) => {
    const hairCare = [];

    // 診断ロジックを元にアイテムを作成
    if (authSalonSettings && authSalonSettings.salonMenus && salonSolutionList && salonSolutionList.hairCare) {
      let resultHairCareItems = [];
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      const resultItems = getResultItemSlugsByDiagnosisLogic(
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        authSalonSettings,
        'Salon Solution Hair'
      );
      // console.log('診断結果ロジックの結果 : Salon Solution Hair', resultItems);
      if (resultItems.recommendedResults !== null) {
        resultHairCareItems.push(resultItems.recommendedResults[0]);
      }
      if (resultItems.otherResults !== null) {
        resultHairCareItems = resultHairCareItems.concat(resultItems.otherResults);
      }
      resultHairCareItems.map(resultHairCareItem => {
        salonSolutionList.hairCare.map(item => {
          if (item.slug === resultHairCareItem.slug) {
            hairCare.push({
              ...item,
              salonSetting: authSalonSettings.salonMenus.treatments.reduce(
                (nv, t) => (item.slug === t.slug ? t : nv),
                ''
              ),
            });
          }
          return null;
        });
        return null;
      });
    }
    return hairCare;
  };

  salonSolutionScalpFilter = (
    salonSolutionList,
    authSalonSettings,
    stylistDiagnosisResults,
    sublimicDiagnosisLogics
  ) => {
    const scalpCare = [];

    // 診断ロジックを元にアイテムを作成
    if (authSalonSettings && authSalonSettings.salonMenus && salonSolutionList && salonSolutionList.scalpCare) {
      let resultScalpCareItems = [];
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      const resultItems = getResultItemSlugsByDiagnosisLogic(
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        authSalonSettings,
        'Salon Solution Scalp'
      );
      if (resultItems.recommendedResults !== null) {
        resultScalpCareItems.push(resultItems.recommendedResults[0]);
      }
      if (resultItems.otherResults !== null) {
        resultScalpCareItems = resultScalpCareItems.concat(resultItems.otherResults);
      }
      resultScalpCareItems.map(resultScalpCareItem => {
        salonSolutionList.scalpCare.map(item => {
          if (item.slug === resultScalpCareItem.slug) {
            scalpCare.push({
              ...item,
              salonSetting: authSalonSettings.salonMenus.spas.reduce((nv, t) => (item.slug === t.slug ? t : nv), ''),
            });
          }
          return null;
        });
        return null;
      });
    }
    return scalpCare;
  };

  homeCareItemHairFilter = (
    homeCareList,
    authSalonSettingData,
    stylistDiagnosisResults,
    sublimicDiagnosisLogics,
    selectedItem
  ) => {
    const hairItems = {
      recommendedResults: [],
      otherResults: [],
    };
    if (stylistDiagnosisResults && sublimicDiagnosisLogics && authSalonSettingData && selectedItem) {
      // 診断結果ロジックを元に結果アイテムのSlug情報を取得
      let resultItems = null;
      resultItems = getResultItemSlugsByDiagnosisLogic(
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        authSalonSettingData,
        'Home Care Items Hair',
        selectedItem
      );
      const concerns = [];
      if (homeCareList && authSalonSettingData && authSalonSettingData.homeCareItems) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in homeCareList) {
          if (authSalonSettingData.homeCareItems.indexOf(homeCareList[key].slug) >= 0) {
            concerns.push(homeCareList[key]);
          }
        }
      }
      const homeCareList2 = [];
      if (concerns) {
        for (let i = 0, max = concerns.length; i < max; i += 1) {
          for (let j = 0, max2 = concerns[i].products.length; j < max2; j += 1) {
            let flg = true;
            for (let k = 0, max3 = homeCareList2.length; k < max3; k += 1) {
              if (homeCareList2[k].slug === concerns[i].products[j].slug) {
                flg = false;
                break;
              }
            }
            if (flg) {
              homeCareList2.push(concerns[i].products[j]);
            }
          }
        }
      }
      if (resultItems && resultItems.recommendedResults && homeCareList2) {
        resultItems.recommendedResults.map(recommendedResult => {
          for (let i = 0, max = homeCareList2.length; i < max; i += 1) {
            if (homeCareList2[i].slug === recommendedResult.slug) {
              hairItems.recommendedResults.push(homeCareList2[i]);
            }
          }
        });
        resultItems.otherResults.map(otherResult => {
          for (let i = 0, max = homeCareList2.length; i < max; i += 1) {
            if (homeCareList2[i].slug === otherResult.slug) {
              hairItems.otherResults.push(homeCareList2[i]);
            }
          }
        });
      }
    }

    return hairItems || null;
  };

  homeCareItemScalpFilter = (
    homeCareList,
    authSalonSettingData,
    stylistDiagnosisResults,
    sublimicDiagnosisLogics,
    selectedItem
  ) => {
    const scalpItems = {
      recommendedResults: [],
      otherResults: [],
    };
    if (stylistDiagnosisResults && sublimicDiagnosisLogics && authSalonSettingData) {
      let resultItems = null;
      resultItems = getResultItemSlugsByDiagnosisLogic(
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        authSalonSettingData,
        'Home Care Items Scalp',
        selectedItem
      );
      //
      // console.log('homeCareItemScalpFilter : フィルタ前', resultItems, selectedItem);
      const slugs = [];
      authSalonSettingData.salonMenus.spas.map(spa => {
        slugs.push(spa.slug);
      });
      if (
        slugs.indexOf('SS-S-Complete') === -1 &&
        slugs.indexOf('SS-S-Lifting') === -1 &&
        slugs.indexOf('SS-S-SolvingProblem') === -1
      ) {
        // SS-S-CompleteとSS-S-LiftingとSS-S-SolvingProblemがOffの場合はアデノバイタルを表示
        resultItems = {
          recommendedResults: [
            { slug: 'HCI-AD-Cleanse-Shampoo-shampoo' },
            // { slug: 'HCI-AD-Treat-Treatment-hairtreatment' },
            { slug: 'HCI-AD-Treat-Treatment-scalptreatment' },
            // { slug: 'HCI-AD-Enhance-Volumeserum-volumeserum' },
            // { slug: 'HCI-AD-Treat-Mask-mask' },
            { slug: 'HCI-AD-Treat-Scalpessence-scalppowershot' },
            { slug: 'HCI-WS-special-WonderShield-wondershield' },
          ],
          otherResults: null,
        };
        // console.log('SS-S-CompleteとSS-S-LiftingとSS-S-SolvingProblemがOff', resultItems);
      } else if (slugs.indexOf('SS-S-Gray') === -1 && slugs.indexOf('SS-S-Growth') === -1) {
        // SS-S-GrayとSS-S-GrowthがOffの場合はプレクレンズ&シャンプーを非表
        if (selectedItem.concern.slug === 'Concern-FFOS') {
          resultItems = {
            recommendedResults: [
              { slug: 'HCI-FF-Cleanse-Shampoo-shampooos' },
              { slug: 'HCI-FF-Treat-Treatment-treatment' },
              { slug: 'HCI-FF-Treat-Scalpessence-purifyingbeautyspa' },
              { slug: 'HCI-WS-special-WonderShield-wondershield' },
            ],
            otherResults: [
              { slug: 'HCI-FF-Cleanse-Shampoo-shampoods' },
              { slug: 'HCI-FF-Cleanse-Shampoo-shampoodd' },
              { slug: 'HCI-FF-Treat-Scalpessence-hydrobeautyspa' },
              { slug: 'HCI-FF-Treat-Scalpessence-claritybeautyspa' },
            ],
          };
        } else if (selectedItem.concern.slug === 'Concern-FFDD') {
          resultItems = {
            recommendedResults: [
              { slug: 'HCI-FF-Cleanse-Shampoo-shampoodd' },
              { slug: 'HCI-FF-Treat-Treatment-treatment' },
              { slug: 'HCI-FF-Treat-Scalpessence-claritybeautyspa' },
              { slug: 'HCI-WS-special-WonderShield-wondershield' },
            ],
            otherResults: [
              { slug: 'HCI-FF-Cleanse-Shampoo-shampoods' },
              { slug: 'HCI-FF-Treat-Scalpessence-hydrobeautyspa' },
              { slug: 'HCI-FF-Treat-Scalpessence-purifyingbeautyspa' },
              { slug: 'HCI-FF-Cleanse-Shampoo-shampooos' },
            ],
          };
        } else {
          resultItems = {
            recommendedResults: [
              { slug: 'HCI-FF-Cleanse-Shampoo-shampoods' },
              { slug: 'HCI-FF-Treat-Treatment-treatment' },
              { slug: 'HCI-FF-Treat-Scalpessence-hydrobeautyspa' },
              { slug: 'HCI-WS-special-WonderShield-wondershield' },
            ],
            otherResults: [
              { slug: 'HCI-FF-Cleanse-Shampoo-shampoodd' },
              { slug: 'HCI-FF-Treat-Scalpessence-purifyingbeautyspa' },
              { slug: 'HCI-FF-Treat-Scalpessence-claritybeautyspa' },
              { slug: 'HCI-FF-Cleanse-Shampoo-shampooos' },
            ],
          };
        }
        // console.log('SS-S-GrayとSS-S-GrowthがOff', resultItems);
      }
      //
      const concerns = [];
      if (homeCareList && authSalonSettingData && authSalonSettingData.homeCareItems) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in homeCareList) {
          if (authSalonSettingData.homeCareItems.indexOf(homeCareList[key].slug) >= 0) {
            concerns.push(homeCareList[key]);
          }
        }
      }
      // console.log('concerns', concerns);
      const homeCareList2 = [];
      if (concerns) {
        for (let i = 0, max = concerns.length; i < max; i += 1) {
          for (let j = 0, max2 = concerns[i].products.length; j < max2; j += 1) {
            let flg = true;
            for (let k = 0, max3 = homeCareList2.length; k < max3; k += 1) {
              if (homeCareList2[k].slug === concerns[i].products[j].slug) {
                flg = false;
                break;
              }
            }
            if (flg) {
              homeCareList2.push(concerns[i].products[j]);
            }
          }
        }
      }
      // console.log('homeCareList2', homeCareList2);
      if (resultItems && resultItems.recommendedResults && homeCareList2) {
        resultItems.recommendedResults.map(recommendedResult => {
          for (let i = 0, max = homeCareList2.length; i < max; i += 1) {
            if (homeCareList2[i].slug === recommendedResult.slug) {
              scalpItems.recommendedResults.push(homeCareList2[i]);
            }
          }
        });
        if (resultItems.otherResults) {
          resultItems.otherResults.map(otherResult => {
            for (let i = 0, max = homeCareList2.length; i < max; i += 1) {
              if (homeCareList2[i].slug === otherResult.slug) {
                scalpItems.otherResults.push(homeCareList2[i]);
              }
            }
          });
        }
      }
    }
    return scalpItems || null;
  };

  handleOpenModal = () => {
    const globalNavi = document.getElementById('globalNavi') || null;
    if (globalNavi) {
      globalNavi.classList.add('modal-opened');
    }
    // const wrapper = document.getElementById('salon-consultation-wrapper') || null;
    // if (wrapper) {
    //   wrapper.style.zIndex = 2000;
    // }
    // window.scrollTo(0, 0);
    // 縦スクロールを無効にする
    document.body.style.overflowY = 'hidden';
    document.body.style.height = '100%';
  };

  handleCloseModal = () => {
    const globalNavi = document.getElementById('globalNavi') || null;
    if (globalNavi) {
      globalNavi.classList.remove('modal-opened');
    }
    // const wrapper = document.getElementById('salon-consultation-wrapper') || null;
    // if (wrapper) {
    //   wrapper.style.zIndex = 'auto';
    // }
    // 縦スクロールを有効にする
    document.body.style.overflowY = 'scroll';
    document.body.style.height = 'auto';
  };

  handleChangeHomeCareHairItems = maskItem => {
    const {
      authSalonSettings,
      updateDiagnosisResult,
      stylistDiagnosisResults,
      sublimicDiagnosisLogics,
      homeCareList,
      homeCareLineList,
    } = this.props;
    const { authSalonSettingData: newAuthSalonSettingData } = homeCareItemFilter(homeCareLineList, authSalonSettings);
    // アイテム
    let homeCareHairItems = null;
    if (homeCareList && newAuthSalonSettingData && stylistDiagnosisResults && sublimicDiagnosisLogics) {
      homeCareHairItems = this.homeCareItemHairFilter(
        homeCareList,
        newAuthSalonSettingData,
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        maskItem
      );
    }
    // console.log('ホームケアアイテム（SalonMenuResult）', homeCareHairItems);
    this.setState({
      homeCareHairItems: homeCareHairItems.recommendedResults.concat(homeCareHairItems.otherResults) || null,
    });
    updateDiagnosisResult({
      selectedHomeCareHairItems:
        homeCareHairItems && homeCareHairItems.recommendedResults ? homeCareHairItems.recommendedResults : null,
      recommendedHomeCareHairItems:
        homeCareHairItems && homeCareHairItems.recommendedResults ? homeCareHairItems.recommendedResults : null,
    });
  };

  handleChangeHomeCareScalpItems = preCleanseShampooItem => {
    const {
      authSalonSettings,
      updateDiagnosisResult,
      stylistDiagnosisResults,
      sublimicDiagnosisLogics,
      homeCareList,
      homeCareLineList,
    } = this.props;
    // console.log('@ preCleanseShampooItem', preCleanseShampooItem);
    const { authSalonSettingData: newAuthSalonSettingData } = homeCareItemFilter(homeCareLineList, authSalonSettings);
    // アイテム
    let homeCareScalpItems = null;
    if (homeCareList && newAuthSalonSettingData && stylistDiagnosisResults && sublimicDiagnosisLogics) {
      homeCareScalpItems = this.homeCareItemScalpFilter(
        homeCareList,
        newAuthSalonSettingData,
        stylistDiagnosisResults,
        sublimicDiagnosisLogics,
        preCleanseShampooItem
      );
    }
    // console.log('ホームケアアイテム（ScalpCare）', homeCareScalpItems);
    this.setState({
      homeCareScalpItems: homeCareScalpItems.recommendedResults.concat(homeCareScalpItems.otherResults) || null,
    });
    updateDiagnosisResult({
      selectedHomeCareScalpItems:
        homeCareScalpItems && homeCareScalpItems.recommendedResults ? homeCareScalpItems.recommendedResults : null,
      recommendedHomeCareScalpItems:
        homeCareScalpItems && homeCareScalpItems.recommendedResults ? homeCareScalpItems.recommendedResults : null,
    });
  };

  handleChangeCurrentScene = sceneId => {
    // const { diagnosisResult } = this.props;
    // const {
    //   selectedHomeCareHairItems,
    //   selectedHomeCareScalpItems,
    //   homeCareHairItems,
    //   homeCareScalpItems,
    //   selectedCareMenu,
    // } = diagnosisResult;
    // //
    // if (sceneId === 'confirm') {
    //   if (selectedCareMenu === CATEGORY_HAIRCARE) {
    //     homeCareHairItems.map(homeCareHairItem => {
    //       if (homeCareHairItem.type === 'Shampoo') {
    //         const arr = [];
    //         for (let i = 0, max = selectedHomeCareHairItems.length; i < max; i += 1) {
    //           if (selectedHomeCareHairItems[i].type === homeCareHairItem.type) {
    //             arr.push(homeCareHairItem);
    //           } else {
    //             arr.push(selectedHomeCareHairItems[i]);
    //           }
    //         }
    //         this.props.updateDiagnosisResult({
    //           selectedHomeCareHairItems: arr,
    //         });
    //       }
    //     });
    //   } else if (selectedCareMenu === CATEGORY_SCALPCARE) {
    //     homeCareScalpItems.map(homeCareScalpItem => {
    //       if (homeCareScalpItem.type === 'Shampoo') {
    //         const arr = [];
    //         for (let i = 0, max = selectedHomeCareScalpItems.length; i < max; i += 1) {
    //           if (selectedHomeCareScalpItems[i].type === homeCareScalpItem.type) {
    //             arr.push(homeCareScalpItem);
    //           } else {
    //             arr.push(selectedHomeCareScalpItems[i]);
    //           }
    //         }
    //         this.props.updateDiagnosisResult({
    //           selectedHomeCareScalpItems: arr,
    //         });
    //       }
    //     });
    //   }
    // }
    this.setState({
      currentSceneId: sceneId,
    });
    window.scrollTo(0, 0);
  };

  render() {
    const { history, copy, selectedCareMenu } = this.props;
    const {
      hairCare,
      inFillItems,
      maskItems,
      scalpCare,
      adenovitalItems,
      aromaItems,
      preCleanseShampooItems,
      homeCareHairItems,
      homeCareScalpItems,
      scrolled,
    } = this.state;

    if (!hairCare || !scalpCare) {
      return null;
    }

    return (
      <React.Fragment>
        {!_.get(copy, 'sublimicDiagnosisResults') ? (
          <PlaceholderWrapper>
            <Placeholder w="100%" h={window.innerWidth > TABLET_P ? '64px' : '35px'} />
          </PlaceholderWrapper>
        ) : (
          <HeaderTab
            current={this.state.currentSceneId}
            sublimicDiagnosisResults={copy.sublimicDiagnosisResults}
            changeCurrentScene={this.handleChangeCurrentScene}
            scrolled={scrolled}
          />
        )}
        <Container>
          <Items className={this.state.currentSceneId}>
            <Item className={this.state.currentSceneId === 'top' ? 'current' : ''}>
              <TopPage changeCurrentScene={this.handleChangeCurrentScene} />
            </Item>
            <Item className={this.state.currentSceneId === 'care' ? 'current' : ''}>
              {selectedCareMenu && selectedCareMenu === CATEGORY_HAIRCARE ? (
                <HairCarePage
                  careItemsInfo={hairCare}
                  inFillItemsInfo={inFillItems}
                  maskItemsInfo={maskItems}
                  handleOpenModal={this.handleOpenModal}
                  handleCloseModal={this.handleCloseModal}
                  handleChangeHomeCareHairItems={this.handleChangeHomeCareHairItems}
                  changeCurrentScene={this.handleChangeCurrentScene}
                />
              ) : null}
              {selectedCareMenu && selectedCareMenu === CATEGORY_SCALPCARE ? (
                <ScalpCarePage
                  careItemsInfo={scalpCare}
                  adenovitalItemsInfo={adenovitalItems}
                  aromaItemsInfo={aromaItems}
                  preCleanseShampooItemsInfo={preCleanseShampooItems}
                  handleOpenModal={this.handleOpenModal}
                  handleCloseModal={this.handleCloseModal}
                  handleChangeHomeCareScalpItems={this.handleChangeHomeCareScalpItems}
                  changeCurrentScene={this.handleChangeCurrentScene}
                />
              ) : null}
              {selectedCareMenu && selectedCareMenu === CATEGORY_HAIR_SCALP_CARE ? (
                <HairAndScalpCarePage
                  hairCareItemsInfo={hairCare}
                  scalpCareItemsInfo={scalpCare}
                  inFillItemsInfo={inFillItems}
                  maskItemsInfo={maskItems}
                  adenovitalItemsInfo={adenovitalItems}
                  aromaItemsInfo={aromaItems}
                  preCleanseShampooItemsInfo={preCleanseShampooItems}
                  handleOpenModal={this.handleOpenModal}
                  handleCloseModal={this.handleCloseModal}
                  handleChangeHomeCareHairItems={this.handleChangeHomeCareHairItems}
                  handleChangeHomeCareScalpItems={this.handleChangeHomeCareScalpItems}
                  changeCurrentScene={this.handleChangeCurrentScene}
                />
              ) : null}
            </Item>
            <Item className={this.state.currentSceneId === 'home-care' ? 'current' : ''}>
              <SelectedCareMenuPage
                homeCareHairItems={homeCareHairItems}
                homeCareScalpItems={homeCareScalpItems}
                handleOpenModal={this.handleOpenModal}
                handleCloseModal={this.handleCloseModal}
                changeCurrentScene={this.handleChangeCurrentScene}
              />
            </Item>
            <Item className={this.state.currentSceneId === 'confirm' ? 'current' : ''}>
              <ConfirmPage
                homeCareHairItems={homeCareHairItems}
                homeCareScalpItems={homeCareScalpItems}
                // handleOpenModal={this.handleOpenModal}
                // handleCloseModal={this.handleCloseModal}
                changeCurrentScene={this.handleChangeCurrentScene}
                history={history}
              />
            </Item>
          </Items>
        </Container>
      </React.Fragment>
    );
  }
}

SublimicDiagnosisResultPage.defaultProps = {
  copy: {},
  authSalonSettings: {},
  sublimicDiagnosisLogics: {},
  stylistDiagnosisResults: null,
  sublimicDiagnosisResult: null,
  selectedCareMenu: CATEGORY_HAIRCARE,
};
SublimicDiagnosisResultPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  authSalonSettings: PropTypes.shape({}),
  diagnosisResult: PropTypes.shape({}).isRequired,
  salonSolutionList: PropTypes.shape({}).isRequired,
  updateDiagnosisResult: PropTypes.func.isRequired,
  sublimicDiagnosisLogics: PropTypes.shape({}),
  stylistDiagnosisResults: PropTypes.shape({}),
  sublimicDiagnosisResult: PropTypes.shape({}),
  homeCareList: PropTypes.shape({}).isRequired,
  homeCareLineList: PropTypes.shape({}).isRequired,
  scalpCameraDiagnosis: PropTypes.shape({}).isRequired,
  selectedCareMenu: PropTypes.string,
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  locale: state.locale,
  authSalonSettings: state.authSalonSettings,
  diagnosisResult: state.diagnosisResult,
  salonSolutionList: state.salonSolutionList,
  sublimicDiagnosisLogics: state.sublimicDiagnosisLogics,
  stylistDiagnosisResults: state.sublimicDiagnosis.stylistDiagnosisResults,
  sublimicDiagnosisResult: state.sublimicDiagnosisResult,
  homeCareList: state.homeCareItemConcerns,
  homeCareLineList: state.homeCareItemList,
  scalpCameraDiagnosis: state.scalpCameraDiagnosis,
  selectedCareMenu: state.diagnosisResult.selectedCareMenu,
});
const mapDispatch = dispatch => ({
  updateDiagnosisResult: data => dispatch(updateDiagnosisResult(data)),
});

export default connect(mapState, mapDispatch)(SublimicDiagnosisResultPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/SublimicDiagnosisResultPage.js